import React from "react";
import { motion } from "framer-motion";
import emailIcon from "../../assets/images/emailWhite.png";
import phoneIcon from "../../assets/images/phoneWhite.png";
import googlePlayIcon from "../../assets/images/googlePlayImage.png";
import appleStoreIcon from "../../assets/images/appleStoreImage.png";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "hooks/useScrollAnimation";
import footerBg from "../../assets/images/footer_bg.png";
import { Link } from "react-router-dom";
import appLogo from "../../assets/images/Logo_footer.png";
import square from "../../assets/images/footerBg/FSquare.png";
import squareTwist from "../../assets/images/footerBg/FSquareRotate.png";
import planet from "../../assets/images/footerBg/FPlanet.png";
import divide from "../../assets/images/footerBg/FUnion.png";
import multiple from "../../assets/images/footerBg/FMultiply.png";
import minus from "../../assets/images/footerBg/FMinus.png";
import plus from "../../assets/images/footerBg/FPulse.png";

import AbsoluteImage from "components/AbsoluteImage";

const fadeIn = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2, delayChildren: 0.2 },
  },
};

const HeaderWithBar = ({
  title,
  fontSize = "text-[18px] md:text-[20px] 2xl:text-[22px]",
}) => {
  return (
    <div className="flex items-center gap-3">
      <h2 className={`font-bold text-[#FFFFFF] leading-[24.2px] ${fontSize}`}>
        {title}
      </h2>
    </div>
  );
};

const Footer = () => {
  const { t } = useTranslation();
  const { ref, controls } = useScrollAnimation({
    once: true,
    margin: "0px 0px -100px 0px",
  });

  return (
    <div className="relative overflow-hidden h-auto flex flex-col items-center justify-center z-30">
      <div className="flex flex-col-reverse lg:flex-row z-40 w-full h-full px-5 lg:px-10 py-5 gap-10">
        <div className="flex-[.40] flex flex-col mt-2 lg:h-[200px] justify-between">
          <div>
            <Link
              to="/"
              className="flex flex-col items-center w-[230px] lg:w-[230px] 2xl:w-[300px]"
            >
              <motion.div className={"w-[100%] h-[100%] mr-2"}>
                <img
                  src={appLogo}
                  alt="logo"
                  className="w-full h-full object-contain"
                />
              </motion.div>
            </Link>

            <div className="pl-3">
              <p className="text-[#FFFFFF] text-[16px] 2xl:text-[22px] leading-[24px] 2xl:leading-[20.94px] w-[100%] mt-3 font-craftyGirls font-bold">
                Fly High with TeachWings
              </p>
            </div>
          </div>

          <div className="pl-2 flex items-center gap-2 mt-4">
            <Link
              to={
                "https://play.google.com/store/apps/details?id=com.teachwings"
              }
              target="_blank"
            >
              <motion.img
                variants={fadeIn}
                src={googlePlayIcon}
                alt="googles_play"
                className="cursor-pointer w-[120px] xl:w-[160px] 2xl:w-[160px] object-contain"
              />
            </Link>
            <Link
              to={
                "https://apps.apple.com/in/app/teachwings/id6747387757"
              }
              target="_blank"
            >
              <motion.img
                variants={fadeIn}
                src={appleStoreIcon}
                alt="apple_store"
                className="cursor-pointer w-[120px]  xl:w-[160px] 2xl:w-[160px] object-contain"
              />
            </Link>
          </div>
        </div>

        <div className="flex-1 w-full flex flex-col md:flex-row justify-between md:mt-5">
          <div className="flex flex-col gap-0 flex-1">
            <HeaderWithBar title={t("footer.contactEnquiry")} />
            <p className="text-[#FFFFFF] text-[16px] 2xl:text-[18px] leading-[20px] 2xl:leading-[24px] w-[70%] mt-5 font-thin]">
              {t("footer.footer_para")}
            </p>
            <div className="flex gap-2 items-center mt-2">
              <div className="w-[17px] h-[13px] 2xl:w-[22px] 2xl:h-[20px]">
                <motion.img
                  variants={fadeIn}
                  src={emailIcon}
                  alt="email"
                  className="w-full h-full object-contain"
                />
              </div>
              <Link to="mailto:support@teachwings.com">
                <p className="text-[#FFFFFF] text-[16px] 2xl:text-[18px] leading-[24px]">
                  support@teachwings.com
                </p>
              </Link>
            </div>
            <div className="hidden gap-2 items-center">
              <div className="w-[14px]">
                <motion.img
                  variants={fadeIn}
                  src={phoneIcon}
                  alt="phone"
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="text-[#FFFFFF] text-[16px] 2xl:text-[18px] leading-[16.94px]">
                +91 123456789
              </p>
            </div>
          </div>

          <div className="flex flex-1 justify-center mt-10 md:mt-0">
            <div className="flex flex-col flex-[.5]">
              <HeaderWithBar title={t("footer.navigate")} />
              <ul className="flex flex-col gap-0 mt-5">
                {[
                  { name: "home", to: "/" },
                  { name: "roles", to: "/#roles" },
                  { name: "features", to: "/#features" },
                  { name: "whyUs", to: "/#whyus" },
                ].map((item) => (
                  <Link key={item} to={item.to}>
                    <li
                      variants={fadeIn}
                      className="text-[16px] 2xl:text-[18px] leading-[24px]  text-white"
                    >
                      {t(`footer.${item.name}`)}
                    </li>
                  </Link>
                ))}
              </ul>
            </div>
            <div className="flex flex-col flex-[.5]">
              <HeaderWithBar title={t("footer.usefullLinks")} />
              <ul className="flex flex-col gap-0 mt-5">
                {[
                  {
                    name: "playStore",
                    to: "https://play.google.com/store/apps/details?id=com.teachwings",
                    target: "_blank",
                  },
                  // { name: "appStore" },
                  {
                    name: "register",
                    to: "https://admin.teachwings.com/signup",
                    target: "_blank",
                  },
                  {
                    name: "login",
                    to: "https://admin.teachwings.com/signin",
                    target: "_blank",
                  },
                ].map((item, index) => (
                  <Link
                    key={index}
                    to={item?.to}
                    {...(item?.target && {
                      target: item?.target,
                    })}
                  >
                    <motion.li
                      key={item}
                      variants={fadeIn}
                      className="text-[16px] 2xl:text-[18px] leading-[24px]  text-white"
                    >
                      {t(`footer.${item.name}`)}
                    </motion.li>
                  </Link>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="py-3 z-[1]">
        <p className="text-[12px] 2xl:text-[14px] text-[#FFFFFF] text-center">
          © 2025 TeachWings. All Rights Reserved{" "}
          <Link to={"/privacy-policy"}>| Privacy Policy</Link>
        </p>
      </div>
      <div className="w-[100%] h-[100%] absolute top-0 left-0 z-[-40] bg-[#0E4555]">
        <img
          src={footerBg}
          alt="footer_bg"
          className="w-full h-full object-fill"
        />
      </div>

      <AbsoluteImage
        src={square}
        styles={
          "hidden lg:block sm:top-[230px] md:top-1 md:left-[-44px] w-[67px] md:w-[107px] h-[107px]"
        }
      />
      <AbsoluteImage
        src={squareTwist}
        styles={
          "hidden lg:block bottom-0 right-0 w-[67px] md:w-[107px] h-[107px]"
        }
      />
      <AbsoluteImage
        src={planet}
        styles={
          "hidden lg:block bottom-[186px] md:bottom-[16px] right-[235px] sm:w-[101px] md:w-[141px] h-[90px]"
        }
      />
      <AbsoluteImage
        src={planet}
        styles={
          "hidden lg:block bottom-[246px] md:bottom-[110px] left-[153px] md:left-[53px] w-[54.42px] md:w-[94.42px] h-[60px]"
        }
      />
      <AbsoluteImage
        src={planet}
        styles={"hidden lg:block top-[16px] left-[600px] w-[94.42px] h-[60px]"}
      />
      <AbsoluteImage
        src={divide}
        styles={
          "hidden lg:block bottom-[50.25px] left-[388px] w-[53px] h-[36px]"
        }
      />
      <AbsoluteImage
        src={minus}
        styles={"hidden lg:block bottom-[120px] left-[50%] w-[44px]"}
      />
      <AbsoluteImage
        src={minus}
        styles={"hidden top-[40px] right-[30px] w-[44px]"}
      />
      <AbsoluteImage
        src={plus}
        styles={
          "hidden lg:block bottom-[80%] right-[0%]  w-[52.72px] h-[52.72px]"
        }
      />
      <AbsoluteImage
        src={multiple}
        styles={
          "hidden lg:block top-[30px] right-[250px] w-[52.72px] h-[52.72px]"
        }
      />
      <AbsoluteImage
        src={multiple}
        styles={
          "hidden lg:block bottom-[80px] left-[507px] w-[52.72px] h-[52.72px]"
        }
      />
    </div>
  );
};

export default Footer;
